import classNames from 'classnames';
import { useEffect } from 'react';
import { AutoTooltip } from '../../../../components/auto-tooltip';
import { CompanyRejectTypeLabelMap } from '../../../../config/company';
import { strToJson } from '../../../../lib';
import getFormatMessage from '../../../../locales/get-format-message';
import { ICompanyRejectType } from '../../../../model';
import {
  CommonStatusStep,
  IAPICompanyFullInfo,
  MDMAuthStatus,
} from '../../../../model/api-modules';
import styles from './index.module.scss';

interface IProps {
  data?: IAPICompanyFullInfo;
  showRejectReasons?: boolean;
}

export const CertInfoViewPanel = (props: IProps) => {
  const { data: companyInfo, showRejectReasons = false } = props;

  useEffect(() => {
    init();
  }, [companyInfo]);

  const init = async () => {
    if (!companyInfo) {
      return;
    }
  };

  const viewInfo: Record<string, Record<string, string | undefined>> = {
    [getFormatMessage('认证信息')]: {
      [getFormatMessage('studio_auth_project_name')]:
        companyInfo?.InternalCertInfo?.projectName,
      [getFormatMessage('studio_auth_project_owner')]:
        companyInfo?.InternalCertInfo?.projectOwner,
      [getFormatMessage(
        'KPI Code'
      )]: `${companyInfo?.InternalCertInfo?.productName}(${companyInfo?.InternalCertInfo?.productCode})`,
    },
  };

  const getRejectReasons = () => {
    if (!companyInfo) {
      return '';
    }
    const rejectArray =
      strToJson<Array<any>>(
        'InternalCertInfo' in companyInfo
          ? companyInfo.RejectReason
          : companyInfo.ManualRejectReason
      ) || [];

    let rejectItemLabels = rejectArray.map((rejectItem) => {
      return (
        CompanyRejectTypeLabelMap[rejectItem.type as ICompanyRejectType] +
        rejectItem.reason
      );
    });

    if (
      !rejectItemLabels.length &&
      companyInfo.MDMStatus === MDMAuthStatus.ApprovalFailed
    ) {
      const mdmRejectReason =
        strToJson<{ code?: number; msg?: string }>(
          companyInfo.MDMRejectReason || ''
        ) || {};
      rejectItemLabels = [getFormatMessage(String(mdmRejectReason.code || ''))];
    }

    return rejectItemLabels.join();
  };

  return (
    <div className={classNames(styles.infoPanel, styles.internalInfoPanel)}>
      <div
        className={classNames(
          styles.internalCertInfoContent,
          styles.infoContent
        )}
      >
        {Object.keys(viewInfo).map((title) => {
          const subTitles = Object.keys(viewInfo[title]);
          return (
            <>
              {subTitles.map((subTitle) => {
                const valueText = viewInfo[title][subTitle] || '--';

                return (
                  <div className={styles.infoItem}>
                    <span className={styles.infoSubTitle}>{subTitle}</span>
                    <AutoTooltip title={valueText} placement="topLeft">
                      <span className={styles.infoValue}>{valueText}</span>
                    </AutoTooltip>
                  </div>
                );
              })}
            </>
          );
        })}
      </div>
      {showRejectReasons && companyInfo?.Status === CommonStatusStep.Reject && (
        <div className={styles.rejectReason}>
          拒绝原因: {getRejectReasons()}
        </div>
      )}
    </div>
  );
};
